import styled from '@emotion/styled';
import {observer} from 'mobx-react-lite';
import React from 'react';

type Props = {
  children?: React.ReactNode;
} & React.TableHTMLAttributes<HTMLTableElement>;

const UFieldsTable = ({children, ...props}: Props): React.ReactElement => (
  <Table {...props}>
    <tbody>{children}</tbody>
  </Table>
);

export const FieldsTable = observer(UFieldsTable);

const Table = styled.table`
  text-align: left;
  border-spacing: unset;
  line-height: 23px;
  width: 100%;

  thead {
    visibility: hidden;
  }
`;
